export default {
  home: {
    title: 'To do | Great Minds Digital',
    playerTitle: '{{name}} | Great Minds Digital',
    greeting: {
      greeting: 'Good morning',
      assessments: {
        subject: 'You have ',
        active: '{{count}} assignment',
        active_plural: '{{count}} assignments',
        predicate: ' for today.'
      }
    },
    noAssessments: {
      mainText: `You don't have any assignments!`,
      subText: `Please come back later`,
      altImage: 'No assessments page'
    },
    assignmentClosed: {
      mainText: `This assignment is closed`,
      subText: `Please contact your teacher or try completing another assignment.`,
      returnAssigment: 'Go to your assignments',
      altImage: 'Assignment is Closed page'
    }
  }
};